import React from 'react';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from '@react-pdf/renderer';
import BrandImage from '../../../../../../../assets/images/UTP.png';

// Styles mirroring the image's visual elements
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 5,
    textAlign: 'left'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20
  },
  logo: {
    width: 150
  },

  titleSection: {
    textAlign: 'center',
    textDecoration: 'underline',
    marginBottom: 10
  },
  academicPlanSection: {
    textAlign: 'center'
  },
  information: {
    marginBottom: 10,
    flexDirection: 'row'
  },
  subtile: {
    fontWeight: 'ultrabold'
  },
  dateSection: {
    textAlign: 'right'
  },
  dateData: {
    fontSize: 5,
    marginBottom: 10
  },
  table: {
    width: '100%', // Ensures the table occupies full width
    borderCollapse: 'collapse' // Prevents extra spacing between cells
  },
  row: {
    flexDirection: 'row'
  },
  headerCell: {
    backgroundColor: '#74569E', // Light gray background color
    padding: 8,
    fontSize: 5, // Smaller font size
    border: 'none', // Light gray border
    textAlign: 'center',
    color: 'white'
  },
  subHeaderCell: {
    backgroundColor: '#BED3E2', // Light gray background color
    padding: 8,
    fontSize: 5, // Smaller font size
    border: 'none', // Light gray border
    textAlign: 'left',
    fontWeight: 'bold'
  },
  colspanCell: { width: '100%' },
  cell: {
    padding: 8,
    fontSize: 5, // Smaller font size
    border: 'none',
    textAlign: 'left'
  },
  colCode: {
    width: '13%'
  },
  colName: {
    width: '28%'
  },
  colHours: {
    width: '10%'
  },
  colCredits: {
    width: '9%'
  },
  colType: {
    width: '10%'
  },
  colPrereq: {
    width: '20%'
  },
  colStatus: {
    width: '10%'
  }
});

const PdfDocument = ({ academicPlan, data, fullName, program }: any) => {
  const now = new Date();
  const limaTime = new Date(now.getTime() + 60 * 1000);

  const formattedDate = `${limaTime.getDate().toString().padStart(2, '0')}/${(
    limaTime.getMonth() + 1
  )
    .toString()
    .padStart(2, '0')}/${limaTime.getFullYear()}`;
  const formattedTime = `${limaTime
    .getHours()
    .toString()
    .padStart(2, '0')}:${limaTime.getMinutes().toString().padStart(2, '0')}`;
  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.header}>
          <Image style={styles.logo} src={BrandImage} />
          <View style={styles.dateSection}>
            <Text style={styles.dateData}>Fecha: {formattedDate}</Text>
            <Text style={styles.dateData}>Hora: {formattedTime}</Text>
          </View>
        </View>
        <Text style={styles.titleSection}>PLAN DE ESTUDIO</Text>
        <Text style={styles.academicPlanSection}>{academicPlan}</Text>
        <View>
          <View style={styles.information}>
            <Text style={styles.subtile}>Programa: </Text>
            <Text>{program}</Text>
          </View>
          <View style={styles.information}>
            <Text style={styles.subtile}>Alumno: </Text>
            <Text>{fullName}</Text>
          </View>

          <Text style={styles.information}>
            (**) A: Aprobado C: Convalidado E: En curso P: Pendiente
          </Text>
          <Text style={styles.information}>
            (***) Las asignaturas de Nivelación y los Cursos Complementos no se
            consideran en el cálculo de las condiciones de egreso.
          </Text>
        </View>
        <View style={styles.table}>
          <View style={styles.row}>
            <View style={[styles.headerCell, styles.colCode]}>
              <Text>Código Curso</Text>
            </View>
            <View style={[styles.headerCell, styles.colName]}>
              <Text>Nombre Curso</Text>
            </View>
            <View style={[styles.headerCell, styles.colHours]}>
              <Text>Horas {'\n'} Semanales(*)</Text>
            </View>
            <View style={[styles.headerCell, styles.colCredits]}>
              <Text>Créditos</Text>
            </View>
            <View style={[styles.headerCell, styles.colType]}>
              <Text>Tipo</Text>
            </View>
            <View style={[styles.headerCell, styles.colPrereq]}>
              <Text>Pre-Requisito</Text>
            </View>
            <View style={[styles.headerCell, styles.colStatus]}>
              <Text>Estado(***)</Text>
            </View>
          </View>
          {data?.map((cycle: any) => (
            <>
              <View style={styles.row}>
                <View style={[styles.subHeaderCell, styles.colspanCell]}>
                  <Text>{cycle?.term}</Text>
                </View>
              </View>
              {cycle?.courses?.map((course: any) => (
                <View style={styles.row} key={course.code}>
                  <View style={[styles.cell, styles.colCode]}>
                    <Text>{course.code}</Text>
                  </View>
                  <View style={[styles.cell, styles.colName]}>
                    <Text>{course.name}</Text>
                  </View>
                  <View style={[styles.cell, styles.colHours]}>
                    <Text>{course.hours}</Text>
                  </View>
                  <View style={[styles.cell, styles.colCredits]}>
                    <Text>{course.credits}</Text>
                  </View>
                  <View style={[styles.cell, styles.colType]}>
                    <Text>{course.type}</Text>
                  </View>
                  <View style={[styles.cell, styles.colPrereq]}>
                    <Text>
                      {course.prerequisites
                        .map((prereq: any) => prereq.code)
                        .join(', ')}
                    </Text>
                  </View>
                  <View style={[styles.cell, styles.colStatus]}>
                    <Text>{course.status}</Text>
                  </View>
                </View>
              ))}
            </>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default PdfDocument;
